import React, { PropTypes } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';

const Gallery = ({ title, items, background, twoItemsPerRow, cta }) => {
  const columnClasses = classnames("columns small-16", {
    "medium-6 large-4": !twoItemsPerRow,
    "medium-8": twoItemsPerRow,
  });

  return (
    <section className={classnames("block block-gallery", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>{ title }</h2>
        </div>
      </div>
      <div className="row align-center">
        {items.map(({ entryType, entryText, image, imageAlt, projectLink, numEntries, numCreatives, projectCategory, creativeUsername, attributionLabel="entry"}) => (
          <div className={columnClasses} key={v4()}>
            <div className={classnames("tile", { "naming" : entryType === "name"})}>

              { image && entryType !== "name" && <img src={image.url} alt={image.alt}/> }

              { entryType === "name" &&
              <div className="as-h3-important name-entry">{ entryText }</div> }

              <div className="tile-meta">
                <h3 className="as-h5-important"><Link to={projectLink}>{ projectCategory }</Link></h3>
                <span className="entry-author">
                  { attributionLabel && attributionLabel + " "} by{' '}
                  <Link to={`/users/${creativeUsername}/`}>{creativeUsername}</Link>
                </span>
                <div className="project-stats">
                  <div className="row">
                    <div className="small-8 columns">
                      <div className="stat-label">entries</div>
                      <div className="stat-value">{numEntries}</div>
                    </div>
                    <div className="small-8 columns">
                      <div className="stat-label">creatives</div>
                      <div className="stat-value">{numCreatives}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>
      { !!cta &&
      <div className="text-center cta">
        <Link to={cta.link}>{ cta.label }</Link>
      </div> }
    </section>
  );
};

Gallery.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  background: PropTypes.string,
  twoItemsPerRow: PropTypes.bool,
  cta: PropTypes.object,
};

export default Gallery;
